export const formatCustomerCountry = (countryCode) => {
  if (!countryCode) return "-";
  const normalized = String(countryCode).toLowerCase();
  if (normalized === "usa" || normalized === "us") return "United States";
  if (normalized === "canada" || normalized === "ca") return "Canada";
  return countryCode;
};
